<template>
    <nav class="d-none d-lg-block" id="social-media-sidebar">
        <ul>
            <li class="side-social facebook" @click="social_counter(1)">
                <social-sharing :url="favourite_url"
							:title="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:description="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:quote="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							hashtags="macal"
							twitter-user=""
							inline-template>
                    <network network="facebook">
                        <font-awesome-icon :icon="['fab', 'facebook-f']" class="text-white" />
                    </network>
                </social-sharing>
            </li>
            <li class="side-social whatsapp" @click="social_counter(2)">
                <social-sharing  :url="favourite_url"
							:title="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:description="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:quote="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							hashtags="macal"
							twitter-user=""
							inline-template>
                    <network network="whatsapp">
                        <font-awesome-icon :icon="['fab', 'whatsapp']" class="text-white" />
                    </network>
                </social-sharing>
            </li>
            <li class="side-social twitter"  @click="social_counter(3)" v-if="more">
                <social-sharing :url="favourite_url"
							:title="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:description="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:quote="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							hashtags="macal"
							twitter-user=""
							inline-template>
                <network network="twitter">
                    <font-awesome-icon :icon="['fab', 'twitter']"  class="text-white" />
                </network>
                </social-sharing>
            </li>
            <li class="side-social email" @click="social_counter(4)" v-if="more">
                <social-sharing :url="favourite_url"
							:title="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:description="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							:quote="car.car_brand+' '+car.model_nsr+' '+car.version_nsr+' con precio mínimo: $'+parsedPrice+' en macal.cl'"
							hashtags="macal"
							twitter-user=""
							inline-template>
                    <network network="email">
                        <font-awesome-icon :icon="['fal', 'envelope']" class="text-white" />
                    </network>
                </social-sharing>
            </li>
            <li class="side-social copy" @click="copy()" v-if="more">
                <font-awesome-icon :icon="['fal', 'copy']" class="text-white" />
            </li>
			<li class="side-social" style="position: relative" @click="more = !more">
				<b class="text-dark" style="font-size: 1rem; position: absolute; top: -5px; left: 5px;" v-if="!more">...</b>
                <font-awesome-icon :icon="['fas', 'compress-alt']" class="text-dark" v-else />
			</li>
        </ul>
    </nav>
</template>

<script>
  export default {
	name: 'rss',
	props: {
		car: {default: null}
	},
	data (){
        return {
			more: false,
            parsedPrice: "",
            favourite_url: window.location.href
        }
	},
	methods: {
        copy(){
            var dummy = document.createElement('input'),
            text = window.location.href;
            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
        },
        social_counter(id){
          this.axios.post("meters/social", {dvl_storage_id: this.car.id, social_media_type_id: id}).then(() => {})
        },
	},
	mounted() {
        this.parsedPrice = new Intl.NumberFormat("es-CL").format(parseInt(this.car.price));
     }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

nav {
  position: fixed;
  top: 18vh;
  right: 0;
  margin-top: 100px;
  z-index: 1030;
}

ul {
  display: block;
  list-style-type: none;
  padding-right: 0;
  text-align: center;
  position: relative;
  background-color: #eee;
  padding: 2px;
  border-radius: 5px 0 0 5px;
}

.side-social {
  width: 30px;
  height: 30px;
  line-height: 25px;
  font-size: 15px;
  color: #fff;
  right: 0;
  transition: 0.2s;
  opacity: .8;
  border-radius: 50%;
  margin: 2px;
  cursor: pointer;
  border: 3px solid #bbb;
}

.side-social:hover {
  opacity: 1;
  transition: 0.2s;
}

.facebook {
  background: #3b5998;
}

.twitter {
  background: #55acee;
}

.whatsapp {
  background: #25D366;
}

.email {
  background: #fccc63;
}

.copy {
  background: #dd4b39;
}
</style>